class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      if (!this.notification.classList.contains('active')) return;
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close(restoreFocus = true) {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(restoreFocus ? this.activeElement : null);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

(() => {
  let refreshController;

  const dismissNotification = () => {
    document.querySelector('cart-notification')?.close(false);
  };

  const cancelRefresh = () => refreshController?.abort();

  window.addEventListener('pagehide', () => {
    cancelRefresh();
    dismissNotification();
  });

  document.addEventListener('submit', (event) => {
    if (event.target.closest('product-form, cart-items, cart-drawer')) cancelRefresh();
  }, true);

  window.addEventListener('pageshow', async (event) => {
    const historyNavigation = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
    if (!event.persisted && !historyNavigation) return;

    dismissNotification();
    cancelRefresh();

    if (document.querySelector('cart-items')) {
      window.location.reload();
      return;
    }

    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    cartIcon.querySelector('.cart-count-bubble')?.remove();
    const controller = new AbortController();
    refreshController = controller;
    const timeout = setTimeout(() => controller.abort(), 8000);
    const url = new URL(window.location.href);
    url.hash = '';
    url.searchParams.set('sections', 'cart-icon-bubble');

    try {
      const response = await fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store',
        signal: controller.signal
      });
      if (!response.ok) return;
      const sections = await response.json();
      if (controller.signal.aborted || !sections['cart-icon-bubble']) return;
      const refreshedIcon = new DOMParser()
        .parseFromString(sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section');
      if (refreshedIcon) cartIcon.innerHTML = refreshedIcon.innerHTML;
    } catch (error) {
      if (error.name !== 'AbortError') console.warn('Cart count refresh unavailable.');
    } finally {
      clearTimeout(timeout);
      if (refreshController === controller) refreshController = null;
    }
  });
})();
